import {
  SHIPPING_TYPE_ALL,
  SHIPPING_TYPE_GET,
  SHIPPING_TYPE_DEL,
  SHIPPING_TYPE_PUT,
  SHIPPING_TYPE_POST,
  SHIPPING_TYPE_LOADING,
  SHIPPING_TYPE_ERROR,
} from '../../actions/types';

const initialState = {
  shippingType: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SHIPPING_TYPE_LOADING:
      return { isLoading: true, isCompleted: true };
    case SHIPPING_TYPE_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case SHIPPING_TYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SHIPPING_TYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SHIPPING_TYPE_POST:
      return { isLoading: false, isCompleted: true };
    case SHIPPING_TYPE_PUT:
      return { isLoading: false, isCompleted: true };
    case SHIPPING_TYPE_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
